import React from "react";
import banner from "../../assets/12_Quienes somos/Sobre nosotros/sobre-nosotros-compromiso-ambiental.webp";

/*eslint-disable */

declare const window: any;
const CompromisoComponent: React.FC = () => {
  return (
    <div className="nuestro-compromiso" style={{ backgroundImage: `url(${banner})` }}>
      <h2 className="title">Nuestro compromiso con la sostenibilidad</h2>
    </div>
  );
};

export default CompromisoComponent;
